import sara1 from './images/sara1.jpg';
import veronika1 from './images/veronika1.jpg';
import kristina1 from './images/kristina1.jpg';

import Splash1_image from './images/splash1.jpg';
import photoGirl1_image from './images/sara1.jpg';
import photoGirl2_image from './images/veronika1.jpg';
import photoGirl3_image from './images/kristina1.jpg';

export const Splash1 = Splash1_image;
export const photoGirl1 = photoGirl1_image;
export const photoGirl2 = photoGirl2_image;
export const photoGirl3 = photoGirl3_image;

export const photos = [
    photoGirl1, Splash1, photoGirl2
]

export const tempPreviewImages = [
    photoGirl1,
    photoGirl2,
    photoGirl3,
];

export const tempPreviewImages2 = [
    Splash1,
    photoGirl2,
    photoGirl3,
]

export const tempPreviewImages3 = [
    photoGirl2,
    Splash1,
    photoGirl3,
]

export const tempPreviewImages4 = [
    photoGirl3,
    photoGirl2,
    Splash1,
]

export const tempCampaigns = [
    {
        "uuid": "demo-campaign",
        "userUuid": "demo-model-user",
        "name": "Sara 2026",
        "modelSlug": "sara",
        "status": "active",
        "budget": 2,
        "data": {"expiresAt": "2026-08-22T00:00:00.000Z"},
        "image": sara1,
        "spent": 187.50,
        "earned": 2450
    }
]

export const tempProducts = [
    { "id": 1, "name": "Premium Photos", "status": "active", "price": 49.99 },
    { "id": 2, "name": "Video Package", "status": "active", "price": 99.99 },
    { "id": 3, "name": "Featured Listing", "status": "active", "price": 29.99 }
]

export const tempTransactions = [
    { "id": 1, "description": "Campaign: Sara 2026", "amount": -187.50, "date": "2026-06-12", "type": "campaign" },
    { "id": 2, "description": "Earning: Sara booking", "amount": 500, "date": "2026-06-11", "type": "earning" },
    { "id": 3, "description": "Product: Premium Photos", "amount": -49.99, "date": "2026-06-10", "type": "product" },
    { "id": 4, "description": "Earning: Veronika booking", "amount": 750, "date": "2026-06-09", "type": "earning" },
    { "id": 5, "description": "Campaign: Sara 2026", "amount": -187.50, "date": "2026-06-05", "type": "campaign" },
    { "id": 6, "description": "Deposit", "amount": 1000, "date": "2026-06-04", "type": "deposit" },
    { "id": 7, "description": "Earning: Kristina booking", "amount": 550, "date": "2026-06-03", "type": "earning" },
    { "id": 8, "description": "Withdrawal", "amount": -2000, "date": "2026-06-01", "type": "withdrawal" },
    { "id": 9, "description": "Earning: Sara booking", "amount": 500, "date": "2026-05-28", "type": "earning" },
    { "id": 10, "description": "Campaign: Sara 2026", "amount": -187.50, "date": "2026-05-26", "type": "campaign" }
]

export const tempPaymentMethods = [
    { "id": 1, "type": "visa", "last4": "4242", "expiry": "09/28", "default": true },
    { "id": 2, "type": "mastercard", "last4": "8831", "expiry": "03/27", "default": false }
]

export const tempPendingWithdrawals = [
    { "id": 1, "amount": 500, "method": "bank", "date": "2026-06-10", "status": "pending" },
    { "id": 2, "amount": 200, "method": "crypto", "date": "2026-06-08", "status": "processing" }
]

export const tempAccountStats = {
    "campaignBalance": 325,
    "plan": null,
    "availableBalance": 1200,
    "totalEarned": 13350,
    "cardType": "visa",
    "cardLast4": "4242"
}

export const tempCampaignStudio = {
    "photos": [sara1, veronika1, kristina1, sara1],
    "description": "One of a kind. A captivating and sensual model exudes an effortless elegance, with every glance and movement drawing attention. Her beauty is mesmerizing, blending natural grace with a magnetic aura that commands presence.",
    "parameters": {
        "height": "165cm",
        "weight": "50kg",
        "body": "36-34-36",
        "hair": "black",
        "eyes": "green",
        "breast": "DD"
    },
    "cityRates": [
        { "duration": "30 Minutes", "incall": 300, "outcall": null },
        { "duration": "1 Hour", "incall": 500, "outcall": 550 },
        { "duration": "2 Hour", "incall": 750, "outcall": 800 },
        { "duration": "3 Hour", "incall": 1000, "outcall": 1050 },
        { "duration": "4 Hour", "incall": 1250, "outcall": 1300 }
    ],
    "travelRates": [
        { "duration": "24 Hours", "incall": 3000, "outcall": 3500 },
        { "duration": "48 Hours", "incall": 5000, "outcall": 5500 },
        { "duration": "72 Hours", "incall": 7500, "outcall": 8000 }
    ],
    "tourSchedule": [
        { "city": "Rome", "from": "2026-06-15", "to": "2026-06-22" },
        { "city": "Milan", "from": "2026-06-24", "to": "2026-06-30" },
        { "city": "Florence", "from": "2026-07-02", "to": "2026-07-08" }
    ]
}

export const tempAccountDashboard = {
    "user": {
        "uuid": "demo-model-user",
        "role": 2,
        "model": "demo-model-profile"
    },
    "balance": {
        ...tempAccountStats,
        "campaignSpend": Math.abs(tempTransactions.filter((transaction) => ['campaign', 'product'].includes(transaction.type) && transaction.amount < 0).reduce((total, transaction) => total + transaction.amount, 0)),
        "customerId": "cus_demo_sadida",
        "paymentMethods": tempPaymentMethods
    },
    "model": {
        "uuid": "demo-model-profile",
        "name": "Sara",
        "slug": "sara",
        "city": "Rome",
        "status": "Active",
        "plan": null,
        "expiresAt": null,
        "image": sara1,
        "description": tempCampaignStudio.description,
        "contacts": {
            "whatsapp": "+39 123 456 7890",
            "telegram": "@saramodel",
            "phone": "+39 123 456 7890",
            "email": "sara@sadida.com"
        }
    },
    "campaigns": tempCampaigns,
    "transactions": tempTransactions
}

export const tempGirls = {
    'rome' : {
        'talent': [
            {
                    "name":"Sara",
                    "image":sara1,
                    "slug":"sara"
                },

                {
                    "name":"Veronika",
                    "image":veronika1,
                    "slug":"veronika"
                },
                {
                    "name":"Angelina",
                    "image":kristina1,
                    "slug":"angelina"
                },
                {
                    "name":"Stacy",
                    "image":veronika1,
                    "slug":"stacy"
                },
                {
                    "name":"Carmen",
                    "image":sara1,
                    "slug":"carmen"
                },
                {
                    "name":"Kristina",
                    "image":kristina1,
                    "slug":"kristina"
                },
            ],
            'title': 'Rome',
            'desc' : 'Rome, a city of seductive allure, where ancient ruins whisper tales of passion and desire. Its streets pulse with sensual energy, blending timeless beauty with an intoxicating mix of pleasure and temptation.'
        },
        'milan' : {
            'talent': [
                {
                    "name":"Veronika",
                    "image":veronika1,
                    "slug":"veronika"
                },
                {
                    "name":"Angela",
                    "image":sara1,
                    "slug":"angela"
                },
                {
                    "name":"Diana",
                    "image":kristina1,
                    "slug":"diana"
                },
                {
                    "name":"Carmen",
                    "image":sara1,
                    "slug":"carmen"
                },
                {
                    "name":"Kristine",
                    "image":kristina1,
                    "slug":"kristine"
                },
                {
                    "name":"Sara",
                    "image":veronika1,
                    "slug":"sara"
                },
            ],
            'title': 'Milan',
            'desc' : 'Milan, a city of sleek elegance and irresistible charm, where fashion and desire intertwine. Beneath its sophisticated exterior lies a seductive rhythm, inviting indulgence in both luxury and lustful pleasures.'
        }
    }
